var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs, Link } from '@mui/material';
import { assertEx } from '@xyo-network/sdk-xyo-js';
import { Link as RouteLink } from 'react-router-dom';
import { FlexRow } from '../FlexBox';
const getPartialPath = (pathParts, index) => {
    const result = [];
    for (let i = 0; i <= index; i++) {
        result.push(`${pathParts[i]}/`);
    }
    return result.join('');
};
const BreadcrumbsEx = (_a) => {
    var _b;
    var { titles, path = document.location.pathname, separator = '|', logo, children } = _a, props = __rest(_a, ["titles", "path", "separator", "logo", "children"]);
    const pathParts = path.split('/');
    //if the url has a trailing '/', remove the last part
    if (((_b = pathParts[pathParts.length - 1]) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        pathParts.pop();
    }
    assertEx(pathParts.length - 1 === (titles === null || titles === void 0 ? void 0 : titles.length), `Path/Title length mismatch: ${JSON.stringify(titles)} with ${JSON.stringify(pathParts)}`);
    return (_jsxs(Breadcrumbs, Object.assign({ separator: separator }, props, { children: [pathParts.map((_pathPart, index) => {
                const path = getPartialPath(pathParts, index);
                return (_jsx(Link, Object.assign({ title: index > 0 ? titles === null || titles === void 0 ? void 0 : titles[index - 1] : 'COIN', color: index === pathParts.length - 1 ? 'textPrimary' : 'inherit', component: RouteLink, to: path }, { children: index > 0 ? (titles === null || titles === void 0 ? void 0 : titles[index - 1]) : (_jsx(FlexRow, { children: typeof logo === 'string' ? _jsx("img", { src: logo }, void 0) : logo }, void 0)) }), path));
            }), children] }), void 0));
};
export default BreadcrumbsEx;
//# sourceMappingURL=BreadcrumbsEx.js.map